"use strict";

var _react = _interopRequireDefault(require("react"));

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.TabConsumer = exports.TabsContext = exports.TabProvider = void 0;

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}

function _typeof(a) {
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (a) {
    return typeof a;
  } : function (a) {
    return a && "function" == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? "symbol" : typeof a;
  }, _typeof(a);
}

function _classCallCheck(a, b) {
  if (!(a instanceof b)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(a, b) {
  for (var c, d = 0; d < b.length; d++) {
    c = b[d], c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty(a, c.key, c);
  }
}

function _createClass(a, b, c) {
  return b && _defineProperties(a.prototype, b), c && _defineProperties(a, c), a;
}

function _possibleConstructorReturn(a, b) {
  return b && ("object" === _typeof(b) || "function" == typeof b) ? b : _assertThisInitialized(a);
}

function _getPrototypeOf(a) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (a) {
    return a.__proto__ || Object.getPrototypeOf(a);
  }, _getPrototypeOf(a);
}

function _assertThisInitialized(a) {
  if (void 0 === a) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return a;
}

function _inherits(a, b) {
  if ("function" != typeof b && null !== b) throw new TypeError("Super expression must either be null or a function");
  a.prototype = Object.create(b && b.prototype, {
    constructor: {
      value: a,
      writable: !0,
      configurable: !0
    }
  }), b && _setPrototypeOf(a, b);
}

function _setPrototypeOf(a, b) {
  return _setPrototypeOf = Object.setPrototypeOf || function (a, b) {
    return a.__proto__ = b, a;
  }, _setPrototypeOf(a, b);
}

function _objectSpread(a) {
  for (var b = 1; b < arguments.length; b++) {
    var c = null == arguments[b] ? {} : arguments[b],
        d = Object.keys(c);
    "function" == typeof Object.getOwnPropertySymbols && (d = d.concat(Object.getOwnPropertySymbols(c).filter(function (a) {
      return Object.getOwnPropertyDescriptor(c, a).enumerable;
    }))), d.forEach(function (b) {
      _defineProperty(a, b, c[b]);
    });
  }

  return a;
}

function _defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}

var TabsContext = _react.default.createContext({
  context: {
    prevActiveTab: {},
    activeTab: {}
  }
});

exports.TabsContext = TabsContext;

var TabProvider = /*#__PURE__*/function (a) {
  function b() {
    var a, c;

    _classCallCheck(this, b);

    for (var d = arguments.length, e = Array(d), f = 0; f < d; f++) {
      e[f] = arguments[f];
    }

    return c = _possibleConstructorReturn(this, (a = _getPrototypeOf(b)).call.apply(a, [this].concat(e))), _defineProperty(_assertThisInitialized(c), "state", {
      tabs: [],
      prevActiveTab: {},
      activeTab: c.props.activeTab
    }), _defineProperty(_assertThisInitialized(c), "addTab", function (a) {
      var b = c.state.tabs.find(function (b) {
        return a.id === b.id;
      });
      b || c.setState(function (b) {
        return {
          tabs: b.tabs.concat(a)
        };
      });
    }), _defineProperty(_assertThisInitialized(c), "removeTab", function (a) {
      c.setState(function (b) {
        return {
          tabs: b.tabs.filter(function (b) {
            return b.id !== a;
          })
        };
      });
    }), _defineProperty(_assertThisInitialized(c), "onClick", function (a) {
      return function () {
        c.setState(function (b) {
          return {
            prevActiveTab: b.activeTab,
            activeTab: a
          };
        });
      };
    }), c;
  }

  return _inherits(b, a), _createClass(b, [{
    key: "render",
    value: function a() {
      return _react.default.createElement(TabsContext.Provider, {
        value: {
          context: _objectSpread({}, this.state, {
            addTab: this.addTab,
            removeTab: this.removeTab,
            onClick: this.onClick
          })
        }
      }, this.props.children);
    }
  }]), b;
}(_react.default.Component);

exports.TabProvider = TabProvider;
var TabConsumer = TabsContext.Consumer;
exports.TabConsumer = TabConsumer;